export enum HEADER_MESSAGE_COLOR {
    DEFAULT = 'default',
    EMPHASIS = 'emphasis',
    NEUTRAL = 'neutral',
    GOOD = 'good',
    BAD = 'bad'
  }  